import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from '../theme';

const StatsCard = ({ title, value, subtitle, icon, variant = 'default', showBorder = true }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const isInline = variant === 'inline';

  return (
    <Box
      backgroundColor="#fff"
      borderRadius="12px"
      border={showBorder ? '1px solid #272C3580' : 'none'}
      p="20px"
      display="flex"
      flexDirection="column"
      height="100%"
    >
      {title && (
        <Typography variant="h6" color={colors.grey[300]} mb="30px" fontWeight="700">
          {title}
        </Typography>
      )}

      <Box display="flex" alignItems="center" gap="15px" flex={isInline ? 1 : 'unset'}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: '12px',
            fontSize: '20px',
            backgroundColor: '#1CCA5B1A',
            color: colors.greenAccent[500],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {icon}
        </Box>

        <Box
          display="flex"
          flexDirection={isInline ? 'row' : 'column'}
          alignItems={isInline ? 'center' : 'flex-start'}
          gap={isInline ? '8px' : '0'}
        >
          <Typography
            variant="h1"
            fontWeight="bold"
            color={colors.grey[100]}
            sx={{ fontSize: '2.5rem' }}
          >
            {value}
          </Typography>
          <Typography
            variant="h5"
            color={colors.grey[200]}
            display="flex"
            alignItems="center"
            gap="6px"
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StatsCard;
